import Styled from "styled-components";

export default Styled.div`    
    height: 100%;

`;
